export default "__VITE_ASSET__B5TETst9__"